import { MyMess } from "../App";

export const checkRequiredHandler = (fields,values,errors) => {
    fields.forEach(field =>{
        if(!values[field]){
            errors[field] = MyMess.general.errors.required;
        }
    })


    return errors;
}